import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import "./transactionSummary.scss";
import { useHistory } from 'react-router-dom';
import { RefreshIcon } from '../../assets/svgs/svg';
import AxisButton from '../../components/button/button';
import Text from '../../components/typography/typgraphy';
import {
  ACC_BALANCE,
  ACC_NUMBER,
  AMOUNT_IN_INR,
  AMOUNT_REQUESTED,
  BANK_CHARGES,
  CONTINUE, CURRENCIES,
  FOREIGN_CURRENCY_TAX,
  GST,
  COMISSION_AMOUNT,
  INSUFFICIENT_FUNDS,
  PAYMENT_FROM,
  PAYMENT_SUMMARY,
  TAX_COLLECTED,
  TOTAL_AMOUNT,
  AMOUNT_IN_INR_TEXT,	
  AMOUNT_IN_INR_ORG,
} from '../../constants/messages';

import { amountWithCurrencyAndComma, getTransactionIdFromURL } from '../../constants/utils';
import { PaymentState } from '../../core/reducers/paymentSummaryReducer';
import { APP_URLS } from '../../constants/constants';
import Loader from '../../components/loader/loader';
import PageHeader from '../../components/pageHeader/pageHeader';
import { IErrorResponseType } from '../../constants/commonTypes';
import { pushDataLayer,TRANSACTION_SUMMARY_CONTINUE, TRANSACTION_SUMMARY_PAGELOAD_PARAM, TRANSACTION_SUMMARY_PAGELOAD_VPV, TRANSACTION_SUMMARY_ACCOUNT_BALANCE_REFRESH } from '../../constants/gaConstants';
import { TransactionState } from '../../core/reducers/transactionDetailsReducer';
import { AuthState } from '../../core/reducers/authReducer';



interface IPaymentSummaryProps {
  getAccountBalanceError: Error | string | null;
  paymentDetails: PaymentState;
  isLoading: boolean;
  getAccountBalance(): void;
  isAuthenticated: boolean;
  getPaymentSummaryDetails(): void;
  resetTransactionSummary(): void;
  error: IErrorResponseType;
  transactionDetails: TransactionState;
  partnerData: AuthState;
}

const TransactionSummary: FunctionComponent<IPaymentSummaryProps> = (props) => {
  const [data, setData] = useState({} as PaymentState)
  const [insufficientFundsError, setInsufficientFundsError] = useState(true)
  const { paymentDetails, isAuthenticated, getAccountBalance, resetTransactionSummary, getPaymentSummaryDetails, error, isLoading, transactionDetails, partnerData} = props;
  const history = useHistory();
  const txnId = getTransactionIdFromURL()


  // GA on page load
  useEffect(() => {
    pushDataLayer(TRANSACTION_SUMMARY_PAGELOAD_VPV(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    pushDataLayer(TRANSACTION_SUMMARY_PAGELOAD_PARAM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
  }, [])

  useEffect(() => {
    if (error) {
      history.push({
        pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
        state: { errorCode: error.code }
      })
    }
  }, [error, history, txnId])


  /**
   * Update Account Balance when Refresh is clicked
   */
  const handleRefresh = async () => {
    pushDataLayer(TRANSACTION_SUMMARY_ACCOUNT_BALANCE_REFRESH(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))

    getAccountBalance()
  }

  /**
   * Get Account details
   */
  useEffect(() => {
    function getAccountDetails() {
      getAccountBalance()
    }
    if (isAuthenticated) {
      getAccountDetails()
    }
  }, [isAuthenticated, getAccountBalance])

  /**
   * Get Payment Summary
   */
  useEffect(() => {
    function getPaymentSummary() {
      getPaymentSummaryDetails()
    }
    if (isAuthenticated && data.isAccountDetailsFetched) {
      getPaymentSummary()
    }
  }, [isAuthenticated, getPaymentSummaryDetails, data.isAccountDetailsFetched])

  /**
   * Set Payment Summary Details to state
   */
  useEffect(() => {
    setData(paymentDetails)
    if (paymentDetails.accBalance < paymentDetails.totalAmt) {
      setInsufficientFundsError(true)
    } else {
      setInsufficientFundsError(false)
    }
  }, [paymentDetails])

  /**
   * Confirm Payment Summary and Proceed
   */
  const handleSubmit = () => {
    pushDataLayer(TRANSACTION_SUMMARY_CONTINUE(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    resetTransactionSummary()
    history.push(`${APP_URLS.TNC.replace(":txnId", txnId)}`);
  }

  
  return (
    <Fragment>
      {isLoading && <Loader />}
      <div className="summary-container">
        <PageHeader className="page-header" />
        <div className="page-header-wrapper">
          <div className="summary-wrapper">
            <div className="account-details details-mob mob">
              <div className="account-details-heading heading-mob">
                <Text fontWeight={600} >{PAYMENT_FROM}</Text>
                <RefreshIcon width={80} height={16} className="refresh-details" onClick={() => handleRefresh()} />
              </div>
              <div className="account-details-wrapper acc-details-mob">
                <div className="account-details-desc">
                  <Text className="acc-number-heading">{ACC_NUMBER}</Text>
                  <Text className="acc-number-desc">{data.accountNo}</Text>
                </div>
                <div className="account-details-desc balance">
                  <Text className="acc-number-heading">{ACC_BALANCE}</Text>
                  <Text className="acc-number-desc">{amountWithCurrencyAndComma(data.accountCurrency, data.accBalance)}</Text>
                </div>
              </div>
            </div>
            <div className="account-details web">
              <div className="account-details-heading">
                <Text fontWeight={600} >{PAYMENT_FROM}</Text>
              </div>
              <div className="account-details-wrapper">
                <div className="account-details-desc">
                  <Text className="acc-number-heading">{ACC_NUMBER}</Text>
                  <Text className="acc-number-desc">{data.accountNo}</Text>
                </div>
                <div className="account-details-desc balance">
                  <Text className="acc-number-heading">{ACC_BALANCE}</Text>
                  <Text className="acc-number-desc">{amountWithCurrencyAndComma(data.accountCurrency, data.accBalance)}</Text>
                </div>
              </div>
              <RefreshIcon width={80} height={16} className="refresh-details" onClick={handleRefresh} />
            </div>
            {insufficientFundsError && <Text className={"error-text"}>{INSUFFICIENT_FUNDS}</Text>}
            <div className="payment-details">
              <div className="payment-summary-wrapper">
                <div className="summary-details-heading">
                  <Text fontWeight={600}>{PAYMENT_SUMMARY}</Text>
                </div>
                <div className="summary-details">
                  <div className="summary">
                    <div className="summary-item">
                      <Text className="amount">{AMOUNT_REQUESTED}</Text>
                      <Text className="amount">{amountWithCurrencyAndComma(data.currency, data.amount)}</Text>
                    </div>
                    {/* when discounted rate is not passed */}
                    {data.rate == data.originalRate && (<div className="summary-item"> 
                      <Text className="amount">
                        {AMOUNT_IN_INR_TEXT} {"( Rate : "} {AMOUNT_IN_INR(data.rate)} {")"}
                      </Text>
                      <Text className='amount'>
                        {amountWithCurrencyAndComma(
                          CURRENCIES.INR,
                          data.inrAmt
                        )}
                      </Text>
                    </div>)}
                    {/* when discounted rate is there */}
                    {data.rate != data.originalRate && (
                      <div className = "arc-disc-org-rate">
                        <div className="summary-item disc-rate">
                          <Text className="amount">
                            {AMOUNT_IN_INR_TEXT} {" @ "} <b>{AMOUNT_IN_INR_ORG(data.rate)}</b> 
                          </Text>
                          <Text className='amount'>
                            {amountWithCurrencyAndComma(
                              CURRENCIES.INR,
                              data.inrAmt
                            )}
                          </Text>
                        </div>
                        <div className="summary-item actual-rate">
                          <Text className="amount actual-rate">
                            {"Actual Rate"} <del>{AMOUNT_IN_INR_ORG(data.originalRate)}</del> 
                          </Text>
                          <Text className='amount'>
                            {""}
                          </Text>
                        </div>
                      </div>
                    )}
                    <div className="summary-item">
                      <Text className="amount">{BANK_CHARGES}</Text>
                      <Text className="amount">{amountWithCurrencyAndComma(CURRENCIES.INR, data.bankCharges)}</Text>
                    </div>
                    <div className="summary-item">
                      <Text className="amount">{TAX_COLLECTED}</Text>
                      <Text className="amount">{amountWithCurrencyAndComma(CURRENCIES.INR, data.sourceTax)}</Text>
                    </div>
                    <div className="summary-item">
                      <Text className="amount">{FOREIGN_CURRENCY_TAX}</Text>
                      <Text className="amount">{amountWithCurrencyAndComma(CURRENCIES.INR, data.fccTax)}</Text>
                    </div>
                    <div className="summary-item">
                      <Text className="amount">{COMISSION_AMOUNT}</Text>
                      <Text className="amount">{amountWithCurrencyAndComma(CURRENCIES.INR, data.commissionAmount)}</Text>
                    </div>
                    <div className="summary-item">
                      <Text className="amount">{GST}</Text>
                      <Text className="amount">{amountWithCurrencyAndComma(CURRENCIES.INR, data.gst)}</Text>
                    </div>
                  </div>
                  <div className="summary-item">
                    <Text className="final amount">{TOTAL_AMOUNT}</Text>
                    <Text fontWeight={600} className="final">{amountWithCurrencyAndComma(CURRENCIES.INR, data.totalAmt)}</Text>
                  </div>
                </div>
              </div>
            </div>
            <div className='time-btn-container'>
              <div className="timestamp">{new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'long',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(Date.now())}</div>
              <div className="submit-btn-container btn-web">
                <AxisButton onClick={() => handleSubmit()} disabled={insufficientFundsError} disableElevation customStyle={"submit-btn-primary"} variant="contained">
                  <Text className={"submit-btn-text"}>{CONTINUE}</Text>
                </AxisButton>
              </div>
            </div>
          </div>
          <div className="submit-btn-container btn-mob">
            <AxisButton onClick={() => handleSubmit()} disabled={insufficientFundsError} disableElevation customStyle={"submit-btn-primary"} variant="contained">
              <Text className={"submit-btn-text"}>{CONTINUE}</Text>
            </AxisButton>
          </div>
        </div>
        
      </div>
      {/* <div className="timestamp">{new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'long',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(Date.now())}</div> */}
      
    </Fragment>
  )
}

export default TransactionSummary;